import GLightbox from 'glightbox'

export default () => {
    const elementImage = document.querySelector('.js-glightbox-image');
    const elementVideo = document.querySelector('.js-glightbox-video');

    if ((elementImage || elementVideo) === null) {
        return false;
    }

    GLightbox({
        selector: '.js-glightbox-image',
        loop: true,
        slideEffect: 'fade',
    });

    GLightbox({
        selector: '.js-glightbox-video',
        videosWidth: 1300,
        loop: true,
        slideEffect: 'fade',
    });

}
